export default __webpack_public_path__ + "static/media/Inter-Regular.dbfe9066.woff";